import { connect, useSelector } from "react-redux";
import {Layout, Layouts, Responsive, WidthProvider} from "react-grid-layout";

import ChartWidget from "../widgets/chartWidget/ChartWidget";
import ListWidget from "../widgets/listWidget/ListWidget";
import MetricWidget from "../widgets/metricWidget/MetricWidget";
import BaseWidget from "../widgets/baseWidget/BaseWidget";
import VideoListWidget from "../widgets/videoListWidget/VideoListWidget";
import NotificationWidget from "../widgets/notificationWidget/NotificationWidget";
import {IGridConfig, IGridConfigItem} from "../../constants/interfaces";

import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import {ensureType} from "../../hooks/ensureType";
import useWindowSize from "../../hooks/useWindowSize";

const ResponsiveGridLayout = WidthProvider(Responsive);

const mapStateToProps = (state: any) => {
	return { grid: state.grids };
};

const selectWidget = (value: IGridConfigItem, width: number, height: number) => {
	const placeholder = <BaseWidget />;
	if (!value) {
		return placeholder;
	}
	const { cell_content_type: widgetType } = value;
	const { cell_id } = value;
	let variant;
	switch (widgetType) {
		case "chart":
			return <ChartWidget cellId={cell_id} />;
		case "list":
			variant = width >= 6 ? "full" : "compact";
			return <ListWidget cellId={cell_id} variant={variant} />;
		case "metric":
			return <MetricWidget cellId={cell_id} width={width} small={height === 1} />;
		case "video_list":
			variant = width >= 6 ? "full" : "compact";
			return <VideoListWidget cellId={cell_id} variant={variant}/>
		case "notification_centre":
			return <NotificationWidget cellId={cell_id} />;
		default: 
			return placeholder;
	}
};

type Props = {
	widgets: IGridConfig,
	grid_type_id: number
}

type Grids = {
	grids: Layout[]
}

const Grid = (props: Props) => {
	const layout = useSelector((state: {grids: Grids}) => state.grids.grids);
	const [ , height ] = useWindowSize();
	const MIN_ROW_HEIGHT = 80;
	const ratio = 8; // Max 4 rows
	const offset = 160; // height of header + margins

	if (!layout) {
		return <div />;
	}

	const layouts: Layouts = {
		lg: layout,
		md: layout,
	};

	const { widgets } = props;

	function getWidget(data: Layout) {
		return ensureType(widgets.find(
			(w) => w.cell_id.toString() === data.i
		));
	}

	return (
		<ResponsiveGridLayout
			className="grid"
			layouts={layouts}
			isResizable={false}
			isDraggable={false}
			breakpoints={{ lg: 1000, md: 468 }}
			cols={{ lg: 8, md: 1 }}
			// useCSSTransforms={true}
			// measureBeforeMount={true}
			rowHeight={Math.max(
				Math.round((height - offset) / ratio),
				MIN_ROW_HEIGHT
			)}
			width={1600}
			autoSize={true}
			margin={[10, 10]}
		>
			{layout?.map((data) => {
				return (
					<div key={data?.i} className={`grid__element ${props?.grid_type_id === 13 && "current"}`}>
						<div key={data?.i} className="grid__element__container">

							{
								selectWidget(getWidget(data), data.w, data.h)
							}
						</div>
					</div>
				);
			})}
		</ResponsiveGridLayout>
	);
};

export default connect(mapStateToProps)(Grid);
